module.exports = __webpack_public_path__ + "static/media/gallery_05_thumb.cb93dc5a.jpg";